import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SKIP_ERROR_TOAST } from 'src/app/shared/http-context-tokens';
import { BaseServices } from '../../kuba.services';
import { PagedResponse } from '../../shared/models/pagedResponse';
import {
  MoveBusinessCandidate,
  MoveBusinessOwner,
  MoveBusinessRequest,
  MoveBusinessResponse,
  MoveBusinessUser
} from '../models/move-business';

@Injectable()
export class MoveBusinessServices {
  private readonly url = `${environment.BASE_URL_V2}/business-moves`;
  constructor(private http: HttpClient) {}
  businesses(
    pageNumber = 1,
    pageSize = 15,
    search = '',
    includeInactive = false,
    owner: MoveBusinessOwner | null = null
  ) {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('search', search)
      .set('includeInactive', includeInactive);
    if (owner != null && owner.BusinessPortalId != null) {
      params = params.set('portalId', owner.BusinessPortalId);
    } else if (owner != null) {
      params = params.set('ownerUserId', owner.Id);
    }
    return this.http.get<PagedResponse<MoveBusinessCandidate>>(
      `${this.url}/businesses/paged`,
      { params }
    );
  }
  owners(applicationId: number) {
    return this.http.get<MoveBusinessOwner[]>(
      `${this.url}/owners/${applicationId}`
    );
  }
  portalUsers(applicationId: number, portalId: number) {
    return this.http.get<MoveBusinessUser[]>(
      `${this.url}/owners/${applicationId}/portals/${portalId}/users`
    );
  }
  getAdminUsersAndPortalTitles() {
    return this.owners(Number(BaseServices.ApplicationId));
  }
  preview(request: MoveBusinessRequest) {
    return this.http.post<MoveBusinessResponse>(
      `${this.url}/preview`,
      request,
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
    );
  }
  commit(request: MoveBusinessRequest) {
    return this.http.post<MoveBusinessResponse>(this.url, request, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true)
    });
  }
}
